// extracted by mini-css-extract-plugin
export var fullWidthButton = "_cq-0";